module.exports = __webpack_public_path__ + "static/media/ipo5.08837acd.png";